import { getIconForTopicBySourceId } from '@klv/organisms/topics-menu/utils/functions';

import * as s from './styles';

import type { ITopicsMenuItem } from './types';

const TopicsMenuItem = ({ selected = false, sourceId, topic = '', url, ...props }: ITopicsMenuItem) => {
  if (!topic) return null;

  return (
    <s.StyledTopicsMenuItem
      to={url}
      selected={selected}
      {...props}
    >
      <s.TopicIcon
        fillColor="currentColor"
        iconName={getIconForTopicBySourceId(sourceId)}
        size={3}
      />
      <s.TopicName
        colorVariant="dark"
        variant="h6"
      >
        {topic}
      </s.TopicName>
    </s.StyledTopicsMenuItem>
  );
};

export default TopicsMenuItem;
